<template>
  <div>
    <section class="section">
      <div class="container content">
        <h1>{{ $t("download.title") }}</h1>
        <p>
          {{ $t("download.text1") }}
          <strong>{{ $t("commons.programName") }}</strong>
          {{ $t("download.text2") }}.
        </p>
      </div>
    </section>
    <section class="section downloads">
      <div class="container content">
        <h2 class="is-sr-only">{{ $t("download.downloadTo") }}:</h2>
        <div class="columns">
          <div class="column is-one-third">
            <p class="has-text-centered">
              <img
                v-if="userPrefersDark"
                alt=""
                class="downloads__logo"
                src="@/assets/images/shared/windows-fff.svg"
              />
              <img
                v-else
                alt=""
                class="downloads__logo"
                src="@/assets/images/shared/windows.svg"
              />
            </p>
            <p class="has-text-centered">
              <a
                :href="$localized('shademotion5installerWindowsExe')"
                @click="
                  $track(
                    'SM-Downloads',
                    'SM5-installer-download',
                    'SM5-Windows-Installer',
                  )
                "
                class="button is-medium is-fixed-width"
                :class="buttonClass"
                ><span class="icon is-medium"
                  ><img
                    alt=""
                    class="downloads__icon"
                    src="@/assets/images/shared/download-fff.svg"
                  />
                </span>
                <span>{{ $t("download.operatingSystems.windows") }}</span></a
              >
            </p>
            <p class="has-text-centered">
              <a
                :href="$localized('shademotion5installerWindows')"
                @click="
                  $track(
                    'SM-Downloads',
                    'SM5-installer-download',
                    'SM5-Windows-Zip-Installer',
                  )
                "
              >
                {{ $t("download.zipVersion") }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container content">
        <p>
          <strong>{{ $t("commons.programName") }}</strong>
          {{ $t("download.runOnline") }}
        </p>
        <p>
          <a
            class="button is-fixed-width"
            :class="linkClass"
            :href="$localized('appV6')"
            >{{ $t("home.buttonRunOnline") }}</a
          >
        </p>
        <template v-if="showPWAInstallButton">
          <br />
          <p
            v-html="
              $t('download.installPWA', {
                programName: $t('commons.programName'),
              })
            "
          ></p>
          <p>
            <button
              class="button is-fixed-width"
              :class="linkClass"
              @click="installPWA"
            >
              {{ $t("download.buttonInstallPWA") }}
            </button>
          </p>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
const userPrefersDark =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export default {
  data() {
    return {
      userPrefersDark,
      pwaInstallInterval: null,
      showPWAInstallButton: false,
    };
  },
  computed: {
    buttonClass() {
      return userPrefersDark ? "is-dark" : "is-success";
    },
    linkClass() {
      return userPrefersDark ? "is-dark" : "is-info";
    },
  },
  methods: {
    checkForInstallPrompt() {
      if (window.installPrompt) {
        clearInterval(this.pwaInstallInterval);
        this.pwaInstallInterval = null;
        this.showPWAInstallButton = true;
      }
    },
    installPWA() {
      window.installPrompt.prompt();

      window.installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          this.$track(
            "SM-Downloads",
            "SM5-pwa-install",
            "pwa-install-accepted",
          );
        } else {
          this.$track(
            "SM-Downloads",
            "SM5-pwa-install",
            "pwa-install-dismissed",
          );
        }
      });

      this.$track(
        "SM-Downloads",
        "SM5-installer-download",
        "SM5-PWA-Installer",
      );
    },
  },
  mounted() {
    this.pwaInstallInterval = setInterval(() => {
      this.checkForInstallPrompt();
    }, 1000);

    this.checkForInstallPrompt();
  },
  beforeDestroy() {
    if (this.pwaInstallInterval) {
      clearInterval(this.pwaInstallInterval);
      this.pwaInstallInterval = null;
    }
  },
};
</script>
